// In-game help viewer. Ported from help.c. The help file is a set of sections
// with plain lines, centred headings ('!') and links ('?ident?text').

import { helpText } from '../render/assets';
import { DrawRect, draw_text } from '../render/surface';
import { executeScene } from '../render/scene';
import { present } from '../render/display';
import { nextTick } from './loop';
import { takeEvents } from './input';
import { S } from './constants';

interface HelpSection {
  identifier: string;
  lines: string[];
}

let sections: HelpSection[] | null = null;
let my_line = 0;
let my_sec = 0;
let my_cursor = 0;
let my_link = 0;
let tick = 0;

function InitHelp(): void {
  sections = [];
  let current: HelpSection | null = null;
  const raw = helpText.split(/\r?\n/);
  for (const line of raw) {
    if (line[0] === "'") continue;
    if (line[0] === ':') {
      current = { identifier: line.slice(1), lines: [] };
      sections.push(current);
      continue;
    }
    if (current) current.lines.push(line);
  }
}

function DisplayHelp(): void {
  executeScene(() => {
  DrawRect(S(23), S(23), S(594), S(434), 0);
  DrawRect(S(24), S(24), S(592), S(432), 200);
  DrawRect(S(25), S(25), S(590), S(430), 255);
  DrawRect(S(26), S(26), S(588), S(428), 200);
  DrawRect(S(27), S(27), S(586), S(426), 100);
  DrawRect(S(30), S(30), S(580), S(420), 20);
  DrawRect(S(35), S(35), S(570), S(410), 60);

  const current = sections![my_sec];
  let follow_link = 0;
  let linkfollow = '';

  my_line = my_cursor - 19;
  if (my_line < 0) my_line = 0;
  if (my_line >= current.lines.length) my_line = current.lines.length - 1;
  for (let i = 0; i < 2; i++) {
    draw_text(S(23) + i, S(40) + (my_cursor - my_line) * S(10), '->', 255);
    draw_text(S(599) + i, S(40) + (my_cursor - my_line) * S(10), '<-', 255);
  }

  for (let i = 0; i < 40; i++) {
    const line_num = my_line + i;
    if (line_num >= 0 && line_num < current.lines.length) {
      const ltext = current.lines[line_num];
      switch (ltext[0]) {
        case '!':
          draw_text(S(40) + (S(560) - (ltext.length - 1) * S(8)) / 2, S(40) + i * S(10), ltext.slice(1), 255);
          break;
        case '?': {
          const rest = ltext.slice(1);
          const sep = rest.indexOf('?');
          const c_ident = rest.slice(0, sep);
          const body = rest.slice(sep + 1);
          draw_text(S(40), S(40) + i * S(10), body, my_cursor === line_num ? 200 + (tick % 16) * 3 : 150);
          if (my_link === 1 && my_cursor === line_num) {
            follow_link = 1;
            linkfollow = c_ident;
          }
          break;
        }
        default:
          draw_text(S(40), S(40) + i * S(10), ltext, 200);
          break;
      }
    }
  }
  tick++;

  if (follow_link) {
    for (let i = 0; i < sections!.length; i++) {
      if (linkfollow === sections![i].identifier) {
        my_sec = i;
        my_cursor = 0;
        break;
      }
    }
    my_link = 0;
  }
  });
}

// Returns 0 to leave help.
function MoveCursor(): number {
  my_link = 0;
  for (const ev of takeEvents()) {
    if (ev.down) {
      if (ev.sym === 'DN' && my_cursor < sections![my_sec].lines.length - 1) my_cursor++;
      if (ev.sym === 'UP' && my_cursor > 0) my_cursor--;
      if (ev.sym === 'ESCAPE') return 0;
      if (ev.sym === 'H') return 0;
      if (ev.sym === 'SP' || ev.sym === 'RETURN') my_link = 1;
    }
  }
  return 1;
}

export async function ShowHelp(): Promise<void> {
  if (sections === null) InitHelp();
  my_line = 0;
  my_sec = 0;
  my_cursor = 0;
  my_link = 0;

  let in_help = 1;
  while (in_help) {
    DisplayHelp();
    present();
    in_help = MoveCursor();
    await nextTick();
  }
}
